export const useAdHocPerformTime = () => {
  const maxDate = new Date();

  return [maxDate];
};
